import "./MonitorAlarmTable.scss";
import filter from "../../../common/images/filter.png";
import { ALARM_TYPE_FILTER, ALARM_PRIORITY_FILTER } from "../../../common/constant/common-constants";
import { convertUTCtoIST } from "../../../common/utils/CommonUtils";

export default function MonitorAlarmTableDesktopView({
    tableRef,
    header,
    sortedEvents,
    selectedTypeFilter,
    selectedPriorityFilter,
    toggleFilterDropdown,
    filterDropdown,
    dropdownRef,
    handleFilterSelect,
    getPriority,
    isLoading,
}) {
    return (
        <>
            <div className="alarm-history-text">Event History</div>
            <div className="alarm-history-data-container">
                <div ref={tableRef} className="alarm-table-container">
                    <table className="alarm-table">
                        <thead className="sticky">
                            <tr>
                                {header?.map((data, count) => {
                                    const canShowPriorityFilter =
                                        selectedTypeFilter === "PHYSIOLOGICAL" ||
                                        selectedTypeFilter === "TECHNICAL";

                                    const isPriorityColumn = data === "PRIORITY";
                                    const isTypeColumn = data === "TYPE";
                                    const shouldShowFilter =
                                        isTypeColumn || (isPriorityColumn && canShowPriorityFilter);

                                    return (
                                        <th
                                            key={count}
                                            className="alarm-header"
                                            style={{ position: "relative" }}
                                        >
                                            <div
                                                className="header-content"
                                                style={{
                                                    cursor: shouldShowFilter ? "pointer" : "default",
                                                }}
                                                onClick={
                                                    shouldShowFilter
                                                        ? () => toggleFilterDropdown(data)
                                                        : undefined
                                                }
                                            >
                                                {data}
                                                {shouldShowFilter && (
                                                    <span className="filter-icon">
                                                        <img src={filter} alt="filter" width="21vw" />
                                                    </span>
                                                )}
                                            </div>

                                            {filterDropdown.open &&
                                                filterDropdown.column === data &&
                                                shouldShowFilter && (
                                                    <div
                                                        ref={dropdownRef}
                                                        className="filter-dropdown"
                                                        style={{
                                                            position: "absolute",
                                                            top: "100%",
                                                            left: 0,
                                                            zIndex: 10,
                                                            minWidth: "9.8vw",
                                                            marginTop: "0.5vh",
                                                            zIndex: 1000,
                                                        }}
                                                    >
                                                        {(data === "TYPE"
                                                            ? ALARM_TYPE_FILTER
                                                            : ALARM_PRIORITY_FILTER
                                                        ).map((f) => (
                                                            <div
                                                                key={f.id}
                                                                onClick={() => handleFilterSelect(f, data)}
                                                                style={{
                                                                    padding: "0.7vw 2vh",
                                                                    cursor: "pointer",
                                                                    fontSize: "0.8vw",
                                                                    lineHeight: "20px",
                                                                    border: "0.6vw solid #333333",
                                                                    background:
                                                                        data === "TYPE"
                                                                            ? f.name === selectedTypeFilter
                                                                                ? "#6D1DF0"
                                                                                : "#333333"
                                                                            : f.name === selectedPriorityFilter
                                                                                ? "#6D1DF0"
                                                                                : "#333333",
                                                                }}
                                                            >
                                                                {f.label}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                        </th>
                                    );
                                })}
                            </tr>
                        </thead>

                        <tbody>
                            {sortedEvents?.map((row, count) => {
                                if (!row) return null;

                                const activeTime = row?.activeTime || '';
                                const resolveTime = row?.resolvedTime || '';

                                const activeIST = convertUTCtoIST(activeTime);
                                const resolveIST = convertUTCtoIST(resolveTime);
                                const priorityData = row?.priority ? getPriority(row.priority) : { color: '', textColor: '', icon: '' };
                                const color = row?.status === 'active' ? priorityData.color : '';
                                const textColor = row?.status === 'active' ? priorityData.textColor : '';

                                let type = '';
                                if (row?.type) {
                                    type = row.type
                                        .split(' ')
                                        .map((t) => t ? t[0].toUpperCase() + t.substring(1).toLowerCase() : '')
                                        .join(' ');
                                }

                                if (!row?.message) return null;

                                return (
                                    <tr key={count}>
                                        <td style={{ backgroundColor: color, color: textColor, fontFamily: "Noto Sans", fontWeight: 400, fontStyle: "normal", fontSize: "0.83vw" }}>
                                            {type || '-'}
                                        </td>
                                        <td style={{ backgroundColor: color }}>
                                            <div className="alarm-priority">
                                                {priorityData.icon && <img alt="priority icon" src={priorityData.icon} className="priority" width="31vw" />}
                                            </div>
                                        </td>
                                        <td style={{ backgroundColor: color, color: textColor }}>
                                            <div className="alarm-name" style={{ fontFamily: "Noto Sans", fontWeight: 400, fontStyle: "normal", fontSize: "0.83vw" }}>
                                                {row.message || '-'}
                                            </div>
                                        </td>
                                        <td style={{ backgroundColor: color, color: textColor }}>
                                            <div className="alarm-time" style={{ fontFamily: "Noto Sans", fontWeight: 400, fontSize: "0.83vw" }}>
                                                {activeIST.time}
                                            </div>
                                            <div className="alarm-date" style={{ fontFamily: "Noto Sans", fontWeight: 400, fontSize: "0.73vw" }}>
                                                {activeIST.date}
                                            </div>
                                        </td>
                                        <td style={{ backgroundColor: color, color: textColor }}>
                                            <div className="alarm-time" style={{ fontFamily: "Noto Sans", fontWeight: 400, fontSize: "0.83vw" }}>
                                                {resolveIST.time}
                                            </div>
                                            <div className="alarm-date" style={{ fontFamily: "Noto Sans", fontWeight: 400, fontSize: "0.73vw", }}>
                                                {resolveIST.date}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    {isLoading && (
                        <div className="spinner-container">
                            <div className="spinner"></div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
